exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.numeric, .date {\n    text-align: right;\n}\nli {\n    text-align: left;\n}\n.list-div {\n    max-width: 300px;\n    margin-left: 50%;\n}\n.associated-hotel {\n    display:block;\n}\n", ""]);

// exports
